module.exports = __webpack_public_path__ + "img/bird-8-left.8498c860.png";